function Canvas(props) {
  const _width = props.width ?? 300;
  const _height = props.height ?? 300;
  return (
    <div>
      <canvas id={props.name} height={_height} width={_width} />
    </div>
  );
}

export default Canvas;
